<template>
  <div class="sub-page-v2">
    <div class="page-hero-small">
      <h1>{{ $t('common.contact') }}</h1>
    </div>
    <div class="container-v2 page-body-v2">
      <div class="contact-layout-v2">
        <div class="contact-info-v2">
          <h3>{{ $t('common.contactInfo') }}</h3>
          <div class="info-item" v-for="(item, i) in contactInfo" :key="i">
            <div class="info-icon">{{ item.icon }}</div>
            <div>
              <h4>{{ item.labelKey ? $t(item.labelKey) : item.label }}</h4>
              <p>{{ displayContactValue(item) }}</p>
            </div>
          </div>
        </div>
        <div class="contact-map-v2">
          <div v-if="mapReady" ref="amapContainer" class="amap-container"></div>
          <div v-else class="map-placeholder">
            <div>
              <strong>{{ contact.mapLabel || contact.companyName || $t('map.location') }}</strong>
              <span v-if="contact.mapLng && contact.mapLat">{{ contact.mapLng }}, {{ contact.mapLat }}</span>
              <span v-else>{{ mapMessage }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getContact } from '@/api/portal'
import { loadAmap } from '@/utils/amap'

export default {
  name: 'ContactV2',
  data() {
    return {
      contact: {},
      map: null,
      mapLoading: false,
      mapReady: false,
      mapMessage: this.$t('map.waitConfig'),
      contactInfo: [
        { icon: '◈', labelKey: 'common.companyName', value: '山东盛博莱电力工程有限公司' },
        { icon: '◉', labelKey: 'common.address', value: '山东省济南市莱芜高新区汇源大街67号高创中心833室' },
        { icon: '◆', labelKey: 'common.phone', value: '0531-76786345' },
        { icon: '▣', labelKey: 'common.email', value: 'cseesbl@163.com' }
      ]
    }
  },
  created() {
    this.loadContact()
  },
  mounted() {
    this.$nextTick(this.initMap)
  },
  beforeDestroy() {
    if (this.map) {
      this.map.destroy()
      this.map = null
    }
  },
  methods: {
    loadContact() {
      getContact().then(data => {
        if (!data || !data.contactId) {
          return
        }
        this.contact = data
        this.contactInfo = [
          { icon: '◈', labelKey: 'common.companyName', value: data.companyName || '山东盛博莱电力工程有限公司' },
          { icon: '◉', labelKey: 'common.address', value: data.address || '山东省济南市莱芜高新区汇源大街67号高创中心833室' },
          { icon: '◆', labelKey: 'common.phone', value: data.phone || '0531-76786345' },
          { icon: '◇', labelKey: 'common.fax', value: data.fax || '' },
          { icon: '▣', labelKey: 'common.email', value: data.email || 'cseesbl@163.com' }
        ].filter(item => item.value)
        this.$nextTick(this.initMap)
      }).catch(() => {})
    },
    initMap() {
      if (this.mapLoading) {
        return
      }
      this.mapLoading = true
      loadAmap().then(AMap => {
        const point = this.getMapPoint()
        if (point) {
          this.renderMap(AMap, point)
          return
        }
        this.geocodeAddress(AMap)
      }).catch(error => {
        this.mapReady = false
        this.mapMessage = error.message || this.$t('map.loadError')
      }).finally(() => {
        this.mapLoading = false
      })
    },
    getMapPoint() {
      const lng = Number(this.contact.mapLng)
      const lat = Number(this.contact.mapLat)
      if (!Number.isFinite(lng) || !Number.isFinite(lat) || !this.isValidChinaPoint(lng, lat)) {
        return null
      }
      return [lng, lat]
    },
    isValidChinaPoint(lng, lat) {
      return lng >= 73 && lng <= 136 && lat >= 3 && lat <= 54
    },
    displayContactValue(item) {
      if (this.$langState.locale !== 'en') {
        return item.value
      }
      if (item.labelKey === 'common.companyName') {
        return 'Shandong Senbole Power Engineering Co., Ltd.'
      }
      if (item.labelKey === 'common.address') {
        return 'Room 833, Gaochuang Center, No. 67 Huiyuan Street, Laiwu High-tech Zone, Jinan, Shandong'
      }
      return item.value
    },
    geocodeAddress(AMap) {
      const address = this.contact.address || '山东省济南市莱芜高新区汇源大街67号高创中心833室'
      if (!address) {
        this.mapReady = false
        this.mapMessage = this.$t('map.noAddress')
        return
      }
      const geocoder = new AMap.Geocoder()
      geocoder.getLocation(address, (status, result) => {
        if (status === 'complete' && result.geocodes && result.geocodes.length) {
          const location = result.geocodes[0].location
          const point = [location.lng, location.lat]
          if (this.isValidChinaPoint(point[0], point[1])) {
            this.renderMap(AMap, point)
          } else {
            this.mapReady = false
            this.mapMessage = this.$t('map.invalidPoint')
          }
        } else {
          this.mapReady = false
          this.mapMessage = this.$t('map.invalidPoint')
        }
      })
    },
    renderMap(AMap, point) {
      this.mapReady = true
      this.$nextTick(() => {
        if (this.map) {
          this.map.destroy()
        }
        this.map = new AMap.Map(this.$refs.amapContainer, {
          center: point,
          zoom: 17,
          viewMode: '2D',
          resizeEnable: true,
          mapStyle: 'amap://styles/normal'
        })
        this.map.addControl(new AMap.Scale())
        this.map.addControl(new AMap.ToolBar({ position: 'RB' }))
        const marker = new AMap.Marker({
          position: point,
          title: this.contact.mapLabel || this.contact.companyName || '公司位置'
        })
        this.map.add(marker)
        this.map.setCenter(point)
        this.map.setZoom(17)
        setTimeout(() => {
          if (this.map) {
            this.map.resize()
          }
        }, 100)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.contact-layout-v2 {
  display: flex;
  gap: 50px;
}

.contact-info-v2 {
  flex: 1;

  h3 {
    font-size: 24px;
    font-weight: 700;
    color: #0f172a;
    margin-bottom: 30px;
  }

  .info-item {
    display: flex;
    align-items: flex-start;
    gap: 20px;
    padding: 24px;
    background: #fff;
    border-radius: 16px;
    margin-bottom: 16px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.04);

    .info-icon {
      width: 48px;
      height: 48px;
      background: linear-gradient(135deg, #3b82f6, #06b6d4);
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 20px;
      flex-shrink: 0;
    }

    h4 {
      font-size: 14px;
      color: #94a3b8;
      margin-bottom: 6px;
    }

    p {
      font-size: 17px;
      font-weight: 600;
      color: #0f172a;
    }
  }
}

.contact-map-v2 {
  width: 480px;
  flex-shrink: 0;

  .amap-container {
    width: 100%;
    height: 100%;
    min-height: 420px;
    overflow: hidden;
    border-radius: 20px;
    box-shadow: 0 8px 40px rgba(0,0,0,0.08);
  }

  .map-placeholder {
    width: 100%;
    height: 100%;
    min-height: 420px;
    background: #f1f5f9;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #64748b;
    font-size: 16px;

    div {
      text-align: center;
    }

    strong,
    span {
      display: block;
      max-width: 320px;
      line-height: 1.7;
    }

    strong {
      color: #0f172a;
      font-size: 20px;
      margin-bottom: 10px;
    }
  }
}

@media (max-width: 960px) {
  .contact-layout-v2 {
    flex-direction: column;
  }
  .contact-map-v2 {
    width: 100%;
  }
}
</style>
